import React from 'react'
import { IArticleVideo } from './types';
import { FlexGrid, Heading, getClassNameFactory } from '@dcl/ui';

import './ArticleVideo.css';
import { boldTypes, types } from '@dcl/ui/dist/elements/Heading';
import { ArticleVideoMixed } from '../../components/ArticleVideoMixed/ArticleVideoMixed';

export const ArticleVideo: React.FC<IArticleVideo> = (
    props: IArticleVideo
) => {
    const { articleVideoMixed, partnerId, privileges, secretKey, heading } = props;
    const getClassName = getClassNameFactory(ArticleVideo.displayName);


    return (
        <div className={getClassName()}>
            <FlexGrid className={getClassName({ descendantName: 'articleVideoContainer' })}>
                <FlexGrid.Row>
                    <FlexGrid.Col
                        xs={12}
                        sm={12}
                        md={12}
                        className={getClassName({ descendantName: 'articleVideoHeading' })}
                    >
                        <Heading type={types.Medium} boldType={boldTypes.medium} className={getClassName({ descendantName: 'articleVideoTitleHeading' })}>
                            {heading}
                        </Heading>
                    </FlexGrid.Col>
                </FlexGrid.Row>
            </FlexGrid>
            <ArticleVideoMixed articleVideoMixed={articleVideoMixed} privileges={privileges} partnerId={partnerId} secretKey={secretKey} />
        </div>
    )
}

ArticleVideo.displayName = 'ArticleVideo';